import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useDailyHabitInterstitialMessageStyles = makeStyles({
  textWrapper: {
    ...shorthands.padding(
      tokens.spacingVerticalS,
      tokens.spacingHorizontalL,
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalXXL),
  },
  title: {
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase600,
    fontSize: tokens.fontSizeBase600,
    color: tokens.colorNeutralForeground1,
    ...shorthands.margin(
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalNone,
      tokens.spacingVerticalM,
      tokens.spacingHorizontalNone),
  },
  description: {
    marginTop: tokens.spacingVerticalNone,
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase400,
    color: tokens.colorNeutralForeground1,
  },
});
